import styled from "styled-components";

export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: white;
  background-color: #c29c33; // A green color for the wallet button
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3e8e41; // A darker shade for hover state
  }
`;
